import React, {useEffect, useRef, useState} from "react";
import classNames from "classnames";
import {observer} from "mobx-react-lite";


import {IconProps} from "../icons";


import {ProgressBarHorizontal} from "../ProgressBarHorizontal";
import {UpgradeNotice} from "../UpgradeNotice/UpgradeNotice";


import "./UpgradeNoticeWithCounter.css"


export interface UpgradeNoticeWithCounterProps {
    header: string
    Icon: React.ComponentType<IconProps>;
    currentLimit: number;
    totalLimit: number;
    className?: string;
    type?: 'info' | 'ai'
}

export const UpgradeNoticeWithCounter = observer((
        {
            header,
            Icon,
            currentLimit,
            totalLimit,
            className,
            type
        }: UpgradeNoticeWithCounterProps) => {

        const UpgradeNoticeWithCounterHeaderRef = useRef<HTMLDivElement | null>(null);
        const [headerWidth, setHeaderWidth] = useState<number>(0);

        useEffect(() => {
            if (UpgradeNoticeWithCounterHeaderRef.current) {
                setHeaderWidth(UpgradeNoticeWithCounterHeaderRef.current.clientWidth);
            }
        }, []);

        return (
            <div className={classNames({
                "UpgradeNoticeWithCounter": true,
                [className!]: className
            })}>
                <div className="UpgradeNoticeWithCounter__HeaderPart title-medium" ref={UpgradeNoticeWithCounterHeaderRef}>
                    <Icon size={20}/>
                    <span className={"UpgradeNoticeWithCounter__header"}>{header}</span>
                    <span className="title-medium-bold">{currentLimit} / {totalLimit}</span>
                </div>
                <ProgressBarHorizontal
                    maxWidth={headerWidth}
                    type={type}
                    progress={currentLimit / totalLimit * 100}/>
                <UpgradeNotice className="UpgradeNoticeWithCounter__upgrade" type={'ai'}/>
            </div>
        )
    }
)
